import {
  Box,
  Button,
  Divider,
  Rating,
  Slider,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

const Filters = ({ filters, setFilters, handleAddParams }) => {
  const [price, setprice] = useState([filters.min_price, filters.max_price]);
  const [Color, setColor] = useState(filters.color);
  const [rating, setRating] = useState(filters.rating);

  let colors = [
    "black",
    "white",
    "brown",
    "red",
    "green",
    "blue",
    "yellow",
    "orange",
  ];
  const handlePriceChange = (val) => {
    setprice(val);
    handleAddParams({
      min_price: val[0],
      max_price: val[1],
    });
    setFilters((prev) => ({
      ...prev,
      min_price: val[0],
      max_price: val[1],
    }));
  };
  const handleColorChange = (val) => {
    setColor(val);
    handleAddParams({ color: val });
    setFilters((prev) => ({
      ...prev,
      color: val,
    }));
  };
  const handleRatingChange = (val) => {
    setRating(val);
    handleAddParams({ rating: val });
    setFilters((prev) => ({
      ...prev,
      rating: val,
    }));
  };

  return (
    <Box position={{ md: "sticky" }} top={{ md: "85px" }} width={"100%"}>
      <Typography variant="h5"> Filters</Typography>
      <Box my={2}>
        <Typography fontSize={"16px"} fontWeight={"500"} my={"5px"}>
          Price Filter
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <p>{price[0]}</p>
          <p>{price[1]}</p>
        </Box>
        <Slider
          getAriaLabel={() => "Temperature range"}
          value={price}
          min={10}
          max={1000000}
          onChange={(e, val) => handlePriceChange(val)}
          valueLabelDisplay="auto"
          disableSwap
        />
        {/* <Button
          size="small"
          variant={"outlined"}
          onClick={() => setFilters( price: [0, 5000] }))}
        >
          Under 5K
        </Button> */}
      </Box>
      <Divider></Divider>
      <Box my={2}>
        <Typography fontSize={"16px"} fontWeight={"500"} my={"5px"}>
          Rating
        </Typography>
        <Rating
          value={rating}
          onChange={(e, val) => handleRatingChange(val)}
        ></Rating>
      </Box>
      <Divider></Divider>
      <Box my={2}>
        <Typography fontSize={"16px"} fontWeight={"500"} my={"5px"}>
          Colors
        </Typography>
        <Box sx={{ display: "flex", gap: "8px" }}>
          {colors?.map((el, i) => (
            <button
              key={el + i}
              name={el}
              style={{
                background: el,
                width: "20px",
                height: "20px",
                borderRadius: "50%",

                border: Color == el ? "3px solid black" : "1px solid #ddd",
              }}
              onClick={(e) => {
                handleColorChange(e.target.name);
              }}
            ></button>
          ))}
        </Box>
      </Box>
      <Divider></Divider>
    </Box>
  );
};

export default Filters;
